import {createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import axiosInstance from "./apiAxios.js";

export const getBookingProviderTags = createAsyncThunk(
	"bookings/getBookingProviderTags",
	async ({ currentOrganizationId }, { rejectWithValue }) => {
		try {
			const { data } = await axiosInstance.get(`/scheduler/get/bookingTags/${currentOrganizationId}`);
			return data;
		} catch (err) {
			notification.error({
				message: "Error",
				description: err.response.data.message || "Login Attempt Failed",
				duration: 3,
			});
			return rejectWithValue(err.response.data.message);
		}
	}
);